import React, { useState } from 'react';
import { MOBILE_WIDTH } from 'const';
import { FEBottomSheet, FEButton } from 'components';
import { useMediaQuery } from 'ui-kit/hooks';
import style from './style.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { $showStartPage } from 'domains/application';
import { useUnit } from 'effector-react';

const StartAppConfirmation = ({
  open,
  onClose,
  value,
  onDeclineConfirmation,
}: {
  open: boolean;
  onClose: () => void;
  value: string | null;
  onDeclineConfirmation: () => void;
}) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery(`(min-width: ${MOBILE_WIDTH}px)`);
  const [isOpen, setisOpen] = useState(true)
  const [showStartPage] = useUnit([
    $showStartPage,
  ]);
  function handleClose() {
    if (onClose) {
      onClose();
      onDeclineConfirmation();
    }
  }

  return (

    (showStartPage ? <div className={style.startNotificationContainercontainer} style={{ display: isOpen ? "flex" : "none" }}>
      <div className={style.topContainer}>
        <div className={style.data}>
          <p className='headline'>Уточните адрес</p>
          <p className='text-2'>Товары и цены зависят от адреса</p>
        </div>
        <div className={style.profileIcon}></div>

      </div>
      <div className={style.submit}>
        <button onClick={() => handleClose()} className={style.submitButton}>Уточнить</button>
        <button
          onClick={() => {
            setisOpen(false)
          }}
          className={style.closeButton}
        >
          Позже
        </button>
      </div>
    </div> : null)

  );
};

export default StartAppConfirmation;
